// extracted by mini-css-extract-plugin
module.exports = {"bondwrapper":"bondwrapper-9bf29194","marginL":"marginL-d8206c74","red":"red-ca1b61df"};